const $inject = [
  "$scope",
  "MessageService",
  "Upload",
];

class FileUploadController {
  constructor(
    $scope,
    MessageService,
    ngFileUpload
  ) {
    this.$scope = $scope;
    /** @var {MessageService} */
    this.MessageService = MessageService;
    this.ngFileUpload = ngFileUpload;

    $scope.file = {loading: false, progress: 0, additional: null};
  }

  submit(form) {
    var self = this;

    var handleSuccess = function (response) {
      if (!response.data.error) {
        self.$scope.file.loading = false;

        self.MessageService.add("success", "The file '" + self.$scope.file.additional.name + "' was successfully uploaded with id " + response.data.file.id + ".");
        self.$scope.file.additional = null;
        if (window.scrollTo) {
          window.scrollTo(0, 0);
        }
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      self.$scope.file.loading = false;

      self.MessageService.add("danger", response.data.message);
      if (window.scrollTo) {
        window.scrollTo(0, 0);
      }
    };

    var handleProgress = function (event) {
      self.$scope.file.progress = Math.floor(100.00 * event.loaded / event.total);
    };

    if (form.$valid) {
      self.$scope.file.loading = true;
      self.ngFileUpload.upload({
        url: "/admin/referral/upload-file",
        data: {
          file: self.$scope.file.additional,
        },
        disableProgress: false,
      }).then(handleSuccess, handleError, handleProgress);
    }
  }
}

FileUploadController.$inject = $inject;
export default FileUploadController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/file-upload.controller.js
 **/